import React, { useRef } from 'react'
import { motion, useInView } from 'framer-motion'

import { getLanguage } from '..';

import layer1 from '../../../../images/layer1.png';
import layer2 from '../../../../images/layer2.png';
import layer3 from '../../../../images/layer3.png';
import layer4 from '../../../../images/layer4.png';
import layer5 from '../../../../images/layer5.png';
import layer6 from '../../../../images/layer6.png';
import layer7 from '../../../../images/layer7.png';
import pdfDownloadIcon from "../../../../images/icons/download-pdf.png"

import './layers.css'

const LayerItem = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });

    const layerList = [
        { image: layer1, name: 'PE' },
        { image: layer2, name: 'PE' },
        { image: layer3, name: 'PE' },
        { image: layer4, name: 'Tie' },
        { image: layer5, name: 'Evoh' },
        { image: layer6, name: 'Tie' },
        { image: layer7, name: 'NY' },
    ]

    return (
        <div ref={ref} className="relative z-2">
            <div className='layer-specs'>
                {layerList.map((layer, index) => (
                    <div key={index} style={{ opacity: isInView ? 1 : 0, transition: `all ${0.9 * index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${0.5 * index}s`}} className='layer-item'>
                        <img src={layer.image} className='layer-img' alt={`layer-${index}` || `Layer Media ${index}`} />
                        <div className='absolute bold layer-item__name'>
                            {layer.name}
                        </div>
                    </div>
                ))}
                
            </div>
        </div>
    )
}

export const Layers = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true });
    
    const content = {
        title: {
            en: `9 Layer barrier <br/> for more protection`,
            sp: `Barrera de 9 capas <br/> para más protección`,
            pt: `Barreira de 9 camadas <br/> para mais proteção`
        },
        description: {
            en: `<p>HERMÉTICA protects your green coffee with Nylon and EVOH, two high barrier materials mixed into our film formulation to keep out oxygen and humidity. This means we keep the fruits of your labor safe until HERMÉTICA is opened to access your coffee for roasting.</p>`,
            sp: `<p>HERMÉTICA ™ protege su café verde con Nylon y EVOH, dos materiales de alta barrera, mezclados en nuestra formulación de película, para evitar el oxígeno y la humedad. Esto significa que mantenemos seguros los frutos de su trabajo hasta que se abra nuevamente HERMÉTICA ™</p>`,
            pt: `<p>O HERMÉTICA ™ protege seu café verde com Nylon e EVOH, dois materiais de alta barreira misturados em nossa formulação de filme para impedir a entrada de oxigênio e umidade. Isso significa que mantemos os frutos do seu trabalho em segurança até que o HERMÉTICATM seja aberto para acessar seu café para torrefação. </p>`
        }
    };

    const listOfFiles = [
        { fileName: '15kg', fileLink: 'https://assets.ctfassets.net/vhts96p7twn6/5Dyi5H1ZqRZ6CTzsJkoBlo/cb779edc75616bb7f990ad15196dba22/15kgbulkcoffeegreenbag_materialspecification_191120.pdf' },
        { fileName: '40kg', fileLink: 'https://assets.ctfassets.net/vhts96p7twn6/Ai7gH9E05iDZV4rwEtUqY/61d1f823375fe1392ba04df962faad1a/40kgbulkcoffeegreenbag_materialspecification_191120.pdf' },
        { fileName: '80kg', fileLink: 'https://assets.ctfassets.net/vhts96p7twn6/2HjrcUa5swmyCWWxyPrfHz/b5a2a938f243654fa17805bd4560545c/80kgbulkcoffeegreenbag_materialspecification_191120.pdf' },
    ]

    const language = getLanguage();

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.3, delayChildren: 0.2 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    return (
        <div id='specSheet' ref={ref} className='relative block py-40 px-32 border-lime-green right'>
            <motion.div 
                className='grid col-2-6 col-1-lg col-1-md col-1-sm' 
                initial="hidden"
                animate={isInView ? "visible" : "hidden"}
                variants={containerVariants}
            >
                <motion.div className='block' variants={itemVariants}>
                    <h2 className='text-3xl' dangerouslySetInnerHTML={{ __html: content.title[language] }} />
                    <div dangerouslySetInnerHTML={{ __html: content.description[language] }} />
                </motion.div>
                <motion.div variants={itemVariants}>
                    <LayerItem />
                </motion.div>
            </motion.div>
            <div className='grid col-2-6 col-1-md col-1-sm align-center'>
                <p className='bold text--dark uppercase'>Download</p>
                <div className='block'>
                    <div className='flex flex-col-lg justify-evenly gap-30'>
                        {listOfFiles.map((item, index)=> (
                            <div key={index} className="flex align-center gap-10" style={{transform: isInView ? "none" : "translateX(-200px)", opacity: isInView ? 1 : 0, transition: `all ${.9*index}s cubic-bezier(0.17, 0.55, 0.55, 1) ${.5*index}s`}}>
                                <img src={pdfDownloadIcon} className='mb-0 w-25' alt={`${item.fileName} Icon`} />
                                <a 
                                href={item.fileLink} 
                                key={index} 
                                className='text--dark text-sm decoration-none uppercase' 
                                target="_blank" 
                                rel="nofollow noopener noreferrer">{item.fileName} - Spec Sheet</a>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}